import { OpenAPIV3 } from 'openapi-types';
import { useMemo } from 'react';

import { DereferencedPathsObject } from '@/pages/api-documentation/constants/types';
import { ItemSecurity } from '@/pages/api-documentation/sections/reference/components/ReferenceView/components/Item';
import { PathItem } from '@/pages/api-documentation/sections/reference/components/ReferenceView/components/PathItem';

interface Props {
  paths: DereferencedPathsObject;
  compact: boolean;
  tagName: string | null;
  security: ItemSecurity;
  servers: OpenAPIV3.ServerObject[] | undefined;
}

export function PathItems({ paths, compact, security, servers, tagName }: Props) {
  return useMemo(() => {
    return Object.entries(paths).map(([pathKey, pathItem]) => {
      if (!pathItem || typeof pathItem === 'string') return null;
      return (
        <PathItem
          compact={compact}
          key={pathKey}
          path={pathKey}
          pathItem={pathItem}
          security={security}
          servers={pathItem.servers ?? servers}
          tagName={tagName}
        />
      );
    });
  }, [paths, compact, security, servers, tagName]);
}
